<div id="details-page" class="modal">
	<div class="title">Transaction Data</div>
	<small>Find more details about the transaction below </small>
  <div *ngIf="data?.transaction?.transactionType" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.transaction_type' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.transactionType}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.balanceBefore" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.balance_before' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{'moniepoint.currency_symbol'|translate}} {{data.transaction.balanceBefore|majorAmount|currency}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.balanceAfter" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.balance_after' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{'moniepoint.currency_symbol'|translate}}  {{data.transaction.balanceAfter|majorAmount|currency}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.agentName" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.agent_name' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.agentName}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.terminalId" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.terminal_id' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.terminalId}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.terminalSerialNo" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.serial_no' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.terminalSerialNo}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.retrievalReferenceNo" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.retrieval_reference_no' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.retrievalReferenceNo}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.stan" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.stan' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.stan}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.authorizationCode" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.authorization_code' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.authorizationCode}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.maskedPAN" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.masked_pan' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.maskedPAN}}
      </div>
    </div>
  </div>


  <div *ngIf="data?.transaction?.airtimeNetwork" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.airtime_network' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.airtimeNetwork}}
      </div>
    </div>
  </div>


  <div *ngIf="data?.transaction?.terminalType" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.terminal_type' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.terminalType|removeUnderscore}}
      </div>
    </div>
  </div>

	<div class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.transaction_reference' | translate | titlecase}}:
			</div>
			<div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{data.transaction.transactionReference}}
			</div>
		</div>
	</div>
	<div *ngIf="data?.transaction?.sourceWallet" class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.source' | translate | titlecase}}:
			</div>
			<div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{data.transaction.sourceWallet}}
			</div>
		</div>
	</div>
	<div *ngIf="data?.transaction?.destinationWallet" class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.destination' | translate | titlecase}}:
			</div>
			<div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{data.transaction.destinationWallet}}
			</div>
		</div>
	</div>
	<div class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.amount' | translate | titlecase}}:
			</div>
			<div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{'moniepoint.currency_symbol'|translate}} {{data.transaction.amount | majorAmount | currency}}
			</div>
		</div>
	</div>

  <div *ngIf="meterToken" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.meter_token' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{meterToken}}
      </div>
    </div>
  </div>

  <div *ngIf="token" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.token' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{token}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.transactionCustomerId" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.meter_number' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.transactionCustomerId}}
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.processingFee" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.processing_fee' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{'moniepoint.currency_symbol'|translate}} {{data.transaction.processingFee | majorAmount | currency}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.destinationBankName" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.beneficiary_bank' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.destinationBankName}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.providerReference" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.provider_reference' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.providerReference}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.destinationAccountNumber" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.beneficiary_account' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.destinationAccountNumber}}
      </div>
    </div>
  </div>
  <div *ngIf="data?.transaction?.destinationAccountName" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.beneficiary_name' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.destinationAccountName}}
      </div>
    </div>
  </div>
	<div class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.response_code' | translate | titlecase}}:
			</div>
			<div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{data.transaction.responseCode}}
			</div>
		</div>
	</div>
	<div class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.response_message' | translate | titlecase}}:
			</div>
			<div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{data.transaction.responseMessage}}
			</div>
		</div>
	</div>

  <div *ngIf="data.transaction.cashoutStatus" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.cashout_status' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        <span [class]="'tag-'+ data?.transaction?.cashoutStatus?.toLowerCase()">{{data?.transaction?.cashoutStatus}}</span>
      </div>
    </div>
  </div>

  <div *ngIf="data.transaction.status" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.transaction_status' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        <span [class]="'tag-'+ data?.transaction?.status?.toLowerCase()">{{data?.transaction?.status}}</span>
      </div>
    </div>
  </div>

  <div *ngIf="data?.transaction?.customerPhoneNumber" class="details-section">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.customer_number' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.customerPhoneNumber}}
      </div>
    </div>
  </div>

  <div class="details-section">
		<div nz-row class="m-t-20">
			<div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
				{{'moniepoint.date' | translate | titlecase}}:
			</div>
			<div nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
				{{data.transaction.transactionDate | date: 'd MMM, y h:mm a'}}
			</div>
		</div>
	</div>

  <div class="details-section" *ngIf="data?.transaction?.lastModifiedOn && data?.transaction?.reversed ">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.reversal_date' | translate | titlecase}}:
      </div>
      <div nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.lastModifiedOn | date: 'd MMM, y h:mm a'}}
      </div>
    </div>
  </div>

  <div class="details-section" *ngIf="data.transaction.reversed">
    <div nz-row class="m-t-20">
      <div nz-col nzXs="12" nzSm="8" nzMd="8" nzLg="8">
        {{'moniepoint.reversal_status' | translate | titlecase}}:
      </div>
      <div class="text-bold break-word" nz-col nzXs="12" nzSm="16" nzMd="16" nzLg="16">
        {{data.transaction.reversed?'REVERSED':''}}
      </div>
    </div>
  </div>

	<div class="m-t-20 text-center text-bold">
		<a (click)="modal.destroy()">Close</a>
	</div>
</div>
